export class InvestmentInfo {
  allowOverSubscription: boolean;
  availableLots: number;
  incrementLot: number;
  enableShareBasedIncrement: boolean;
  incrementShare: number;
  tierIncrementSteps: number[];
  maximumTargetAmount: number;
  minimumLots: number;
  minimumTargetAmount: number;
  overSubscriptionAmount: number;
  pricePerShare: number;
  sharePerLot: number;
}
